import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Maps from '../../../store/map';
import { Translate } from '../../../localization';

function SearchBar(props) {
    const handleChanged = (e) => {
        props.lsportsActions.inplay.search(e.target.value);
    };

    const openSeachBar = () => {};

    let { search } = props.lSports.inplay;

    return (
        <div className="sport-header pt-2 disable-select">
            <div className="sports-box-row" style={{ height: '40px' }}>
                <div className="sport-search-bar show-search pb-2">
                    <input
                        type="text"
                        className="ml-2 form-control search-bar"
                        autoFocus
                        placeholder={Translate.searchHere}
                        value={search ? search : ''}
                        onChange={handleChanged}
                    />
                    <Link className="search-close-btn" to="/inplay">
                        <i className="material-icons" onClick={openSeachBar}>
                            close
                        </i>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default connect(Maps.mapLSportsStateToProps, Maps.mapLSportsDispatchToProps)(SearchBar);
